<div class="summary-operation-container">
    <div
            class="close-modal"
            (click)="closeModal()"
            *ngIf="showXIcon"
    >
        <span>X</span>
    </div>
    <div class="box-container">
        <div class="box summary-operation-title">
                        <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                    d="M22.4997 0.333008C10.5397 0.333008 0.833008 10.0397 0.833008 21.9997C0.833008 33.9597 10.5397 43.6663 22.4997 43.6663C34.4597 43.6663 44.1663 33.9597 44.1663 21.9997C44.1663 10.0397 34.4597 0.333008 22.4997 0.333008ZM16.628 31.2947L8.84967 23.5163C8.00467 22.6713 8.00467 21.3063 8.84967 20.4613C9.69467 19.6163 11.0597 19.6163 11.9047 20.4613L18.1663 26.7013L33.073 11.7947C33.918 10.9497 35.283 10.9497 36.128 11.7947C36.973 12.6397 36.973 14.0047 36.128 14.8497L19.683 31.2947C18.8597 32.1397 17.473 32.1397 16.628 31.2947Z"
                                    fill="#39A84A"/>
                        </svg>
            <div class="mt-3" [ngClass]="titleStyle">
                {{'password.success' | translate}}
            </div>
        </div>
    </div>
</div>
